export default __webpack_public_path__ + "img/cf271607e93dbb1c3621d141143e7a11.png";